import * as THREE from 'three';
import {
  Line3
} from 'three';
let lineColor;

// export default function drawHintCylinder(point1, point2, mode) {
//     if(mode === 'draw'){
//       lineColor = new THREE.Color( 0xff0000 );
//     }else{
//       lineColor = new THREE.Color( 0x0000ff )
//     }
//    let vstart = point1.clone();
//     let vend = point2

//     var material = new THREE.LineBasicMaterial({
//       color: lineColor,
//       linewidth: 5
//     });
//     var geometry = new THREE.Geometry();
//     geometry.vertices.push(
//       vstart,
//       vend
//     );
//      let hintObject = new THREE.Line(geometry, material)
//      hintObject.userData.length = hintObject.geometry.vertices[0].distanceTo(hintObject.geometry.vertices[1])
//   return hintObject
// }
export default class Draw {
  constructor() {
      this.hoverLineColor = new THREE.Color(0x0000ff),
      this.drawLineColor = new THREE.Color(0xfeff00),
      this.hoverSteelColor = new THREE.Color(0x0000ff),
      this.drawSteelColor = new THREE.Color(0xff0000),
      this.steelMaterial = new THREE.LineBasicMaterial({
        linewidth: 3,
        transparent: true,
      }),
      this.steelFaces = new THREE.MeshBasicMaterial({ color: 0x00000, transparent: true})
  };

  drawLine(start, end, mode, steelViewMode) {
    //console.log(steelViewMode)
    if(steelViewMode === 'halfSteelVisible'){
      this.steelFaces.visible = true
      this.steelMaterial.visible = true
      this.steelFaces.opacity = 0.5
    } 
    if( steelViewMode === 'fullVisible'){
      this.steelFaces.visible = true
      this.steelMaterial.visible = true
      this.steelFaces.opacity = 1
    }
    if( steelViewMode === 'onlyCenterLines'){
      this.steelFaces.visible = false
      this.steelMaterial.visible = false
    }
    this.start = start.clone();
    this.end = end.clone();
    this.length = new Line3(this.start, this.end).distance()
    if (mode === 'draw') {
      lineColor = this.drawLineColor
      this.steelMaterial.color.set(this.drawSteelColor)
    } else {
      lineColor = this.hoverLineColor
      this.steelMaterial.color.set(this.hoverSteelColor)
    }
    var material = new THREE.LineBasicMaterial({
      color: lineColor,
      linewidth: 5
    });
    var geometry = new THREE.Geometry();
    geometry.vertices.push(
      start,
      end
    );
    let line = new THREE.Line(geometry, material)
    line.userData.length = this.length
    return this.drawSteelItem(this.start, this.end, this.length, line)
    //return line
  }

  drawSteelItem(start, end, length, line) {
    const geometry = new THREE.BoxGeometry(100, 100, length);
    const cube = new THREE.Mesh(geometry, this.steelFaces.clone())
    const geo = new THREE.EdgesGeometry(geometry);
    const wireframe = new THREE.LineSegments(geo, this.steelMaterial.clone());
    var position = end.clone().add(start).divideScalar(2);
    var orientation = new THREE.Matrix4(); //a new orientation matrix to offset pivot
    var offsetRotation = new THREE.Matrix4(); //a matrix to fix pivot rotation
    orientation.lookAt(start, end, new THREE.Vector3(0, 1, 0)); //look at destination
    offsetRotation.makeRotationX(Math.PI); //rotate 90 degs on X
    orientation.multiply(offsetRotation); //combine orientation with rotation transformations
    wireframe.geometry.applyMatrix(orientation)
    wireframe.position.set(position.x, position.y, position.z)
    cube.geometry.applyMatrix(orientation)
    cube.position.set(position.x, position.y, position.z)
    line.userData.steel = wireframe;
    line.userData.steelFaces = cube;
    return line
  }
}